module.exports = __webpack_public_path__ + "img/message-catch.100ab21e.svg";